<template>
  <SelectComponent
    v-model="selectedValues"
    :values="normalizedItemTypes"
    :label="label"
    :required="required"
    :name="name"
    :errors="errors"
    :edition-mode="editionMode"
    :alphabetical-order="true"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { computed } from 'vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent'

export default {
  name: 'SelectItemTypeNormalised',
  components: { SelectComponent },
  props: {
    editionMode: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    modelValue: {
      type: [Array, Number],
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    oldList: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const selectedValues = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value)
    })
    return { selectedValues }
  },
  computed: {
    ...mapGetters('metadata', {
      normalizedItemTypesOld: 'getMetadataNormalizedItemTypes',
      normalizedItemTypesNew: 'getMetadataNormalizedItemTypesNewList'
    }),
    normalizedItemTypes() {
      if(this.oldList) return this.normalizedItemTypesOld
      return this.normalizedItemTypesNew
    },
    label() {
      if(this.oldList) return this.$t('global.item_type_devis_normalised')
      return this.$t('global.item_type_devis_normalised_2025')
    },
    name() {
      if(this.oldList) return 'item_type_devis_normalised'
      return 'item_type_devis_normalised_2025'
    }
  }
}
</script>
